import axios from 'api/axios'
import { UploadRequestOption } from 'rc-upload/lib/interface'

export interface FileUpload {
	url: string
}

const upload = async (
	options: UploadRequestOption<FileUpload>
): Promise<FileUpload> => {
	const { onSuccess, onError, file, onProgress } = options
	try {
		/**
		 * Creating FormData to send the file to the server
		 */
		const formData = new FormData()
		formData.append('file', file)

		/**
		 * Sending the file to the server
		 * and getting the response
		 * and parsing it to JSON
		 * and then returning the response
		 * to the caller
		 */

		const { data } = await axios.post<FileUpload>('file/upload', formData, {
			onUploadProgress: (event: ProgressEvent) => {
				/**
				 * Calculating the progress
				 * and sending it to the caller
				 * by calling the onProgress callback
				 * if it exists
				 */

				if (onProgress !== undefined) {
					onProgress({ ...event, percent: (event.loaded / event.total) * 100 })
				}
			},
		})

		if (onSuccess !== undefined) {
			onSuccess(data)
		}

		return data
	} catch (error: any) {
		if (onError !== undefined) {
			onError(error)
		}
		throw error
	}
}

export default upload
